export default __webpack_public_path__ + "static/media/fd6.b74ae4aa.jpg";